import React from 'react';
import InputVariableServer from '../../../../Components/InputVariableServer';
import './style.scss';

const PMS_VARIABLES = [
	{ keyVariable: 'sendOutletOnClosedOrders', type: 'checkbox' },
];

const PmsVariableServer = () => {
	if (!PMS_VARIABLES.length) {
		return null;
	}

	return (
		<div className="pms-variable-server-container">
			{PMS_VARIABLES.map(variable => (
				<InputVariableServer key={variable.keyVariable} {...variable} />
			))}
		</div>
	);
};

export default PmsVariableServer;
